export default __webpack_public_path__ + "static/ok-2f4a272e93e8d60a859b0dc12dd35d8f.wav";